export default "__VITE_ASSET__CPTHR2Dt__"